import { render, staticRenderFns } from "./paymentV2.vue?vue&type=template&id=8e4cf9e4&scoped=true&"
import script from "./paymentV2.vue?vue&type=script&lang=js&"
export * from "./paymentV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4cf9e4",
  null
  
)

export default component.exports